module.exports = __webpack_public_path__ + "static/media/plus_store.afe48d93.svg";